"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genBtcJumpCkbVirtualTx = void 0;
const base_1 = require("@ckb-lumos/base");
const error_1 = require("../error");
const utils_1 = require("../utils");
const rgbpp_1 = require("../utils/rgbpp");
const constants_1 = require("../constants");
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
/**
 * Generate the virtual ckb transaction for the jumping tx from BTC to CKB
 * @param collector The collector that collects CKB live cells and transactions
 * @param xudtTypeBytes The serialized hex string of the XUDT type script
 * @param rgbppLockArgsList The rgbpp assets cell lock script args array whose data structure is: out_index | bitcoin_tx_id
 * @param transferAmount The XUDT amount to be transferred
 * @param toCkbAddress The receiver ckb address
 * @param witnessLockPlaceholderSize(Optional) The WitnessArgs.lock placeholder bytes array size and the default value is 5000
 * @param ckbFeeRate(Optional) The CKB transaction fee rate, default value is 1100
 * @param btcTestnetType(Optional) The Bitcoin Testnet type including Testnet3 and Signet, default value is Testnet3
 * @param btcConfirmationBlocks(Optional) The BTC confirmation blocks for BTC Time lock args
 */
const genBtcJumpCkbVirtualTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ collector, xudtTypeBytes, rgbppLockArgsList, transferAmount, toCkbAddress, witnessLockPlaceholderSize, ckbFeeRate, btcTestnetType, btcConfirmationBlocks, }) {
    var _b, e_1, _c, _d;
    const isMainnet = toCkbAddress.startsWith('ckb');
    const xudtType = base_1.blockchain.Script.unpack(xudtTypeBytes);
    if (!(0, utils_1.isUDTTypeSupported)(xudtType, isMainnet)) {
        throw new error_1.TypeAssetNotSupportedError('The type script asset is not supported now');
    }
    const deduplicatedLockArgsList = (0, utils_1.deduplicateList)(rgbppLockArgsList);
    const rgbppLocks = deduplicatedLockArgsList.map((args) => (0, rgbpp_1.genRgbppLockScript)(args, isMainnet, btcTestnetType));
    let rgbppTargetCells = [];
    let rgbppOtherTypeCells = [];
    try {
        for (var _e = true, rgbppLocks_1 = __asyncValues(rgbppLocks), rgbppLocks_1_1; rgbppLocks_1_1 = yield rgbppLocks_1.next(), _b = rgbppLocks_1_1.done, !_b; _e = true) {
            _d = rgbppLocks_1_1.value;
            _e = false;
            const rgbppLock = _d;
            const cells = yield collector.getCells({ lock: rgbppLock, isDataMustBeEmpty: false });
            (0, rgbpp_1.throwErrorWhenRgbppCellsInvalid)(cells, xudtTypeBytes, isMainnet);
            const targetCells = cells.filter((cell) => (0, utils_1.isScriptEqual)(cell.output.type, xudtTypeBytes));
            const otherTypeCells = cells.filter((cell) => !(0, utils_1.isScriptEqual)(cell.output.type, xudtTypeBytes));
            rgbppTargetCells = [...rgbppTargetCells, ...targetCells];
            rgbppOtherTypeCells = [...rgbppOtherTypeCells, ...otherTypeCells];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (!_e && !_b && (_c = rgbppLocks_1.return)) yield _c.call(rgbppLocks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    rgbppTargetCells = rgbppTargetCells.sort(rgbpp_1.compareInputs);
    rgbppOtherTypeCells = rgbppOtherTypeCells.sort(rgbpp_1.compareInputs);
    const { inputs, sumInputsCapacity: sumUdtCapacity, sumAmount, } = collector.collectUdtInputs({
        liveCells: rgbppTargetCells,
        needAmount: transferAmount,
    });
    let sumInputsCapacity = sumUdtCapacity;
    (0, rgbpp_1.throwErrorWhenTxInputsExceeded)(inputs.length);
    const rgbppCellCapacity = (0, utils_1.calculateRgbppCellCapacity)(xudtType);
    const toLock = (0, ckb_sdk_utils_1.addressToScript)(toCkbAddress);
    if ((0, utils_1.isLockArgsSizeExceeded)(toLock.args)) {
        throw new Error('The lock script size of the to ckb address is too large');
    }
    let needPaymasterCell = false;
    const needRgbppChange = sumAmount > transferAmount;
    // To simplify, when the xUDT does not need change, all the capacity of the inputs will be given to the receiver
    const receiverOutputCapacity = needRgbppChange ? BigInt(rgbppTargetCells[0].output.capacity) : sumInputsCapacity;
    // The BTC time cell does not need to be bound to the BTC UTXO
    const outputs = [
        {
            lock: (0, rgbpp_1.genBtcTimeLockScript)(toLock, isMainnet, btcTestnetType, btcConfirmationBlocks),
            type: xudtType,
            capacity: (0, utils_1.append0x)(receiverOutputCapacity.toString(16)),
        },
    ];
    const outputsData = [(0, utils_1.append0x)((0, utils_1.u128ToLe)(transferAmount))];
    if (needRgbppChange) {
        const isCapacitySufficient = (0, rgbpp_1.isRgbppCapacitySufficientForChange)(sumInputsCapacity, receiverOutputCapacity);
        needPaymasterCell = !isCapacitySufficient;
        // When the capacity of inputs is enough for the outputs, the sender needs to recover the excess capacity.
        const udtChangeCapacity = isCapacitySufficient ? sumInputsCapacity - receiverOutputCapacity : rgbppCellCapacity;
        outputs.push({
            // The Vouts[0] for OP_RETURN and Vouts[1] for RGBPP assets, BTC time cells don't need btc tx out_index
            lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(1), isMainnet, btcTestnetType),
            type: xudtType,
            capacity: (0, utils_1.append0x)(udtChangeCapacity.toString(16)),
        });
        outputsData.push((0, utils_1.append0x)((0, utils_1.u128ToLe)(sumAmount - transferAmount)));
    }
    const targetRgbppOutputLen = outputs.length;
    for (const [index, otherRgbppCell] of rgbppOtherTypeCells.entries()) {
        inputs.push({
            previousOutput: otherRgbppCell.outPoint,
            since: '0x0',
        });
        sumInputsCapacity += BigInt(otherRgbppCell.output.capacity);
        outputs.push(Object.assign(Object.assign({}, otherRgbppCell.output), { 
            // Vouts[targetRgbppOutputLen + 1], ..., Vouts[targetRgbppOutputLen + rgbppOtherTypeCells.length] for other RGBPP assets
            lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(targetRgbppOutputLen + index + 1), isMainnet, btcTestnetType) }));
        outputsData.push(otherRgbppCell.outputData);
    }
    const cellDeps = yield (0, utils_1.fetchTypeIdCellDeps)(isMainnet, { rgbpp: true, xudt: true }, btcTestnetType);
    if (needPaymasterCell) {
        cellDeps.push((0, constants_1.getSecp256k1CellDep)(isMainnet));
    }
    const witnesses = [];
    const lockArgsSet = new Set();
    const allRgbppCells = rgbppTargetCells.concat(rgbppOtherTypeCells);
    for (const cell of allRgbppCells) {
        if (lockArgsSet.has(cell.output.lock.args)) {
            witnesses.push('0x');
        }
        else {
            lockArgsSet.add(cell.output.lock.args);
            witnesses.push(constants_1.RGBPP_WITNESS_PLACEHOLDER);
        }
    }
    const ckbRawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    if (!needPaymasterCell) {
        const txSize = (0, ckb_sdk_utils_1.getTransactionSize)(ckbRawTx) + (witnessLockPlaceholderSize !== null && witnessLockPlaceholderSize !== void 0 ? witnessLockPlaceholderSize : (0, rgbpp_1.estimateWitnessSize)(deduplicatedLockArgsList));
        const estimatedTxFee = (0, utils_1.calculateTransactionFee)(txSize, ckbFeeRate);
        const changeCapacity = BigInt(outputs[outputs.length - 1].capacity) - estimatedTxFee;
        ckbRawTx.outputs[ckbRawTx.outputs.length - 1].capacity = (0, utils_1.append0x)(changeCapacity.toString(16));
    }
    const virtualTx = Object.assign({}, ckbRawTx);
    const commitment = (0, rgbpp_1.calculateCommitment)(virtualTx);
    return {
        ckbRawTx,
        commitment,
        needPaymasterCell,
        sumInputsCapacity: (0, utils_1.append0x)(sumInputsCapacity.toString(16)),
    };
});
exports.genBtcJumpCkbVirtualTx = genBtcJumpCkbVirtualTx;
